import { VettingTabsEnum } from "src/utils/enums/VettingTabsEnum";
import { ApplicantListItem, DynamicKanbanColumn, DynamicApplicationStatus } from "../applicants/ApplicantListItem";
import { ApplicantsFilter } from "../applicants/ApplicantsFilter";
import { VettingDetailsTabsEnum } from "src/utils/enums/VettingDetailsTabsEnum";
import { InterviewDetails } from "./InterviewDetailsInterface";
import { SubscriptionPlanCategoryEnum } from "src/utils/enums/PartnerSubscription";
import { SubscriptionPlanInterface } from "../payment/SubscrptionPlanInterface";
import { ListApplicationStagesItem } from "../job/Job.store";

export interface VettingStoreInferface {
    jobId: string;
    isLoadingList: boolean;
    isLoadingUnlocking: boolean;
    isLoadingSingleAction: boolean;
    loadingSingleActionApplicantId: string;
  isLoadingMultipleAction: boolean;
    isLoadingTalentAcquisitionSync?: boolean;
    isLoadingApplicantDetails: boolean;
    showAiMatchingLabels: boolean;
    isLoadingRateInterview: boolean;
    selectedApplicant: ApplicantListItem;
    activeTab: VettingTabsEnum;
    activeDetailsTab: VettingDetailsTabsEnum;
    applicantsList: ApplicantListItem[];
    totalCount: number;
    countSuggested: number;
    countApplied: number;
    countVetted: number;
    countShortlist: number;
    countFinalist: number;
    countRejected: number;
    totalCountOfSelectedTab: number;
    filters: ApplicantsFilter;
    selectedFilters: ApplicantsFiltersEnumObject;
    selectedFiltersRow: ApplicantsFiltersEnumObject;
    isCurrentPageResetFromFilters: boolean;
    isFiltersMenuVisible: boolean;
    showInterviewMethodModal: boolean;
    isFiltersReset: boolean;
    viewsRemaining: number;
    lookupsData: any;
    recentlyViewedApplicants: string[];
    selectedApplicants: ApplicantListItem[];
    filterErrors: ApplicantsFiltersEnumObject;
    mobileScrollOffsetForList: number;
    justViewedChats?: string[];

    showSubscriptionModal: boolean;
    showCloseJobModal: boolean;
    showReopenJobModal: boolean;
    showConsumedJobPostModal: boolean;
    showUnlocksConsumedModal: boolean;
    showRecommendationEducationalModal: boolean;
    showCancelInterviewsModal: boolean;
    isBackendRecommending: boolean;
    interviewDetails: InterviewDetails;
    isLoadingInterviewDetails: boolean;
    isLoadingFetchingVideoInterview: boolean;
    showSaveHoursWithSaudModal: boolean;
    showSaudOnItModal: boolean;
    saudInterviewsTourStep: "pick" | "act" | "menu" | "sent" | "summary" | "full" | null;
    showIrrelevantApplicants: boolean;
    showBulkMessageModal: boolean;
    loadingSendBulkMsg: boolean;
    showShareJobModal: boolean;
    isSideBarOpen: boolean;
    resetSelectedApplicantsIds: boolean;
    evaluationGateBlock: {
        applicationExternalIds: string[];
        message?: string;
    } | null;

    // Legacy static columns (kept for backward compatibility during migration)
    applicantsAppliedKanbanList: ApplicantListItem[];
    applicantsAppliedKanbanListCount: number;
    applicantsInterviewedKanbanList: ApplicantListItem[];
    applicantsInterviewedKanbanListCount: number;
    applicantsShortlistedKanbanList: ApplicantListItem[];
    applicantsShortlistedKanbanListCount: number;
    applicantsFinalistKanbanList: ApplicantListItem[];
    applicantsFinalistKanbanListCount: number;
    applicantsAppliedKanbanListPage: number;
    applicantsInterviewedKanbanListPage: number;
    applicantsShortlistedKanbanListPage: number;
    applicantsFinalistKanbanListPage: number;
    applicantsAppliedKanbanListLoading: boolean;
    applicantsInterviewedKanbanListLoading: boolean;
    applicantsShortlistedKanbanListLoading: boolean;
    applicantsFinalistKanbanListLoading: boolean;
    kanbanColumnsCounts: Record<string, number>; // Dynamic column counts: columnId -> count

    // Dynamic columns structure
    kanbanColumns: DynamicKanbanColumn[]; // Column definitions from backend
    kanbanColumnsData: Record<string, {
        applicants: ApplicantListItem[];
        count: number;
        page: number;
        loading: boolean;
    }>;
    isLoadingKanbanColumns: boolean;
    reloadKanbanColumns: boolean;
    applicantsToMoveBetweenKanbanColumns: ApplicantsToMoveBetweenKanbanColumns | null;

    // Dynamic application statuses
    applicationStatuses: DynamicApplicationStatus[]; // Status definitions from backend
    isLoadingApplicationStatuses: boolean;

    applicantNotes: ApplicantNoteItem[];
    selectedApplicantNote: ApplicantNoteItem | null;
    isLoadingApplicantNotes: boolean;
    isSavingApplicantNote: boolean;
    jobDynamicStages: ListApplicationStagesItem[];
    isLoadingJobDynamicStages: boolean;
    isLoadingDeleteJobDynamicStages: boolean;
    isLoadingUpsertJobDynamicStages: boolean;
}

export interface FilterSection {
    title: string;
    content: React.ReactNode;
}

export enum LocalFilterEnum {
    INDUSTRIES = 'experience_by_industry',
    EXPERIENCE = 'years_of_experience',
    NATIONALITY = 'nationality',
    EDUCATION_LEVEL = 'education_level',
    AGE = 'age',
    GENDER = 'gender',
    PREFERRED_CONTRACT_TYPE = 'preferred_contract_type',
    SALARY_EXPECTATION = 'salary_expectation',
    ENGLISH_PROFICIENCY = 'english_proficiency',
    APPLICANTS = 'applicants',
    DISTRICTS = 'districts',
    JOB_LOCATION = 'job_location',
    STATUS = 'status',
    ACTIVE_IN_LAST_DAYS = 'active_in_last_days',
    SEARCH_RADIUS = 'search_radius',
    SAUDI_INTERVIEW_STATUS = 'saud_interview_status',
    OTHER_FILTERS = 'other_filters',
    SCREENING_QUESTION_FILTERS = 'screening_question_filters',
};

export type ApplicantsFiltersEnumObject = Partial<{ [key in LocalFilterEnum]: any }>;

export interface PmaInitialState {
    isLoadingSubscriptionPlans: boolean;
    isLoadingFtPartnerSubscriptionInfo: boolean;
    isLoadingPreparePurchaseProduct: boolean;
    subscriptionPlans: SubscriptionPlanInterface[];
    ftPartnerSubscriptionInfo: any;
}

export interface ApplicantsToMoveBetweenKanbanColumns {
    sourceColumnId: string | null;
    applicantIds: string[];
    destinationColumnId: string;
}

export interface ListApplicantNotesRequestParam {
    jobApplicationId?: string;
    workerExternalId?: string;
    isOffline?: boolean;
    limit?: number;
    skip?: number;
}


export interface ApplicantNoteItem {
    externalId: string;
    note: string;
    createdAt: number;
    updatedAt?: number;
    ownerName: string;
    ownerExternalId: string;
}

export interface UpsertApplicantNoteRequestParam {
    note?: string;
    jobApplicationId?: string;
    workerExternalId?: string;
    noteId?: string;
    isOffline?: boolean;
}

export interface UpsertApplicantNoteRequestBody {
    note: string;
}
export enum OperationEnum {
    ADD = 'ADD',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
}


export class ManageApplicantRejectionReasonsRequestBody {
    operation: OperationEnum;
    rejectionReasonId?: string;
    rejectionReasonText?: string;
}

